import { Injectable, signal } from '@angular/core';
import { DateRange } from '@app/shared/components/date-range/utils/date-range.model';



@Injectable({ providedIn: 'root' })
export class DateRangeService {
  private _range = signal<DateRange | null>(null);
  range = this._range.asReadonly();

  setRange(range: DateRange) {
    this._range.set(range);
  }
}
